import { render } from "./ChatVIew.vue?vue&type=template&id=3afd7efa"
import script from "./ChatVIew.vue?vue&type=script&lang=js"
export * from "./ChatVIew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__